<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" @close="closeDialog" slot="title">
      <template slot="title">
        <div>
          <h3>Change password</h3>
          <el-divider style="font-weight: bold"></el-divider>
        </div>
      </template>
      <el-form
        :model="form"
        class="demo-form-inline"
        label-width="250px"
        :rules="editFormRules"
        ref="editFormRef"
      >

            <el-form-item label="Account:" prop="loginAccount">
              <el-input disabled
                v-model="form.loginAccount"
              ></el-input>
            </el-form-item>

            <el-form-item label="New password:" prop="newPassword">
              <!-- <el-input v-model="form.newPassword" placeholder="Please enter new  passowrd" ></el-input> -->
              <passinput v-model="form.newPassword" placeholder="Please enter new  passowrd"></passinput>
            </el-form-item>

             <el-form-item label="Confirm new Password:" prop="newPassword1">
              <!-- <el-input v-model="form.newPassword1" placeholder="Please enter Confirm new Password"></el-input> -->
              <passinput v-model="form.newPassword1" placeholder="Please enter Confirm new Password"></passinput>
            </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="save">Change password</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import passinput from '@/components/passInput/PassInput.vue'

export default {
  components: {
    passinput
  },
  props: {
    dialogPwdVisible: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      entity: {},
      dialogVisible: this.dialogPwdVisible,
      form:{
        loginAccount:null,
        newPassword:null,
        newPassword1:null,
      },
        

      // 添加表单的验证规则对象
      editFormRules: {
        newPassword: [
          {
            required: true,
            message: 'password is required',
            trigger: 'blur',
          },
          {
            min: 8,
            message: 'Password regular error,Length must longer than 8',
            trigger: 'blur',
          },
        ],
        newPassword1: [
          {
            required: true,
            message: 'password is required',
            trigger: 'blur',
          },
          {
            min: 8,
            message: 'Password regular error,Length must longer than 8',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {

    closeDialog() {
      this.form = {}
      this.$emit('closeDialog')
    },
    //传递用户ID
    setUserId(loginAccount){


        this.form.loginAccount =loginAccount


    },
      // 点击按钮保存
    save() {

        this.$refs.editFormRef.validate(async (valid) => {

        if (!valid) return

         const loading = this.$loading({
          lock: true,
          text: 'saving ...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.$post('auth/updateOtherPwd', this.form).then(({ data: res }) => {
          loading.close()
          if (res.ok) {

              this.closeDialog()
            return this.$message.success(res.msg)
            
          } else {
            this.$message.error(res.msg)
          }
          
        }) .catch(err=>{
           loading.close()
        })
      })
    },
  },
  watch: {
    dialogPwdVisible(oldValue, newValue) {
      this.dialogVisible = this.dialogPwdVisible
    },
  },
}
</script>

<style>
</style>